// Accessible tabs: [role=tab] buttons switch [role=tabpanel] panels (aria-controls). Arrow keys move between tabs.
class STabs extends HTMLElement {
  #ac;

  connectedCallback() {
    this.#ac = new AbortController();
    const opts = { signal: this.#ac.signal };
    this.addEventListener('click', (event) => {
      const tab = event.target instanceof Element ? event.target.closest('[role="tab"]') : null;
      if (tab && this.contains(tab)) this.#select(tab);
    }, opts);
    this.addEventListener('keydown', (event) => {
      const tab = event.target instanceof Element ? event.target.closest('[role="tab"]') : null;
      if (!tab || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
      const tabs = this.#tabs();
      let index = tabs.indexOf(tab);
      if (event.key === 'ArrowRight') index = (index + 1) % tabs.length;
      if (event.key === 'ArrowLeft') index = (index - 1 + tabs.length) % tabs.length;
      if (event.key === 'Home') index = 0;
      if (event.key === 'End') index = tabs.length - 1;
      event.preventDefault();
      this.#select(tabs[index]);
      tabs[index].focus();
    }, opts);
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }

  #tabs() {
    return [...this.querySelectorAll('[role="tab"]')];
  }

  #select(selected) {
    for (const tab of this.#tabs()) {
      const active = tab === selected;
      tab.setAttribute('aria-selected', String(active));
      tab.tabIndex = active ? 0 : -1;
      const panel = document.getElementById(tab.getAttribute('aria-controls') || '');
      if (panel) panel.hidden = !active;
    }
    // Rails inside the newly shown panel recalculate their arrows.
    window.dispatchEvent(new Event('resize'));
  }
}

if (!customElements.get('s-tabs')) customElements.define('s-tabs', STabs);
